/** Safari/iOS-only pinch events; typed loosely since TS lacks GestureEvent. */
const GESTURE_EVENTS = ["gesturestart", "gesturechange", "gestureend"];

const cancel = (event: Event): void => {
  if (event.cancelable) {
    event.preventDefault();
  }
};

const blockMultiTouch = (event: TouchEvent): void => {
  if (event.touches.length > 1) {
    cancel(event);
  }
};

/** ctrl+wheel is how trackpad pinch and desktop zoom reach the page. */
const blockCtrlWheel = (event: WheelEvent): void => {
  if (event.ctrlKey) {
    cancel(event);
  }
};

/**
 * Removes every browser zoom gesture. CSS touch-action is ignored by some
 * Android WebView/TWA builds and by Chrome's "force enable zoom" setting, so
 * the gestures are cancelled at the event level too. Single-finger touches are
 * never cancelled, so scrolling and rapid tapping stay intact.
 */
export const installZoomLock = (target: Document = document): (() => void) => {
  const options = { passive: false } as const;

  target.addEventListener("touchstart", blockMultiTouch, options);
  target.addEventListener("touchmove", blockMultiTouch, options);
  target.addEventListener("dblclick", cancel, options);
  target.addEventListener("wheel", blockCtrlWheel, options);
  for (const name of GESTURE_EVENTS) {
    target.addEventListener(name, cancel, options);
  }

  return () => {
    target.removeEventListener("touchstart", blockMultiTouch);
    target.removeEventListener("touchmove", blockMultiTouch);
    target.removeEventListener("dblclick", cancel);
    target.removeEventListener("wheel", blockCtrlWheel);
    for (const name of GESTURE_EVENTS) {
      target.removeEventListener(name, cancel);
    }
  };
};
